export default "__VITE_ASSET__C_q_J6qh__"